// Teksten van de familie-functies (w4; docs/DESIGN.md §8.F): wensen, deelpagina, kalenders,
// familie en vrienden, berichten, plus de kiosk-schermen. Je-vorm, korte zinnen.
export const familyNl = {
    nav: {
        wishes: 'Wensen',
        messages: 'Berichten',
        calendars: 'Kalenders',
        family: 'Familie',
    },
    common: {
        save: 'Opslaan',
        saved: 'Opgeslagen.',
        add: 'Toevoegen',
        edit: 'Bewerken',
        remove: 'Weghalen',
        undo: 'Ongedaan maken',
        copy: 'Kopieer link',
        copied: 'Link gekopieerd.',
        readOnly: 'Alleen lezen',
        everyone: 'Iedereen',
        loading: 'Even laden…',
        retry: 'Opnieuw proberen',
        error: 'Er ging iets mis. Probeer het opnieuw.',
        back: 'Terug',
        close: 'Sluiten',
        whoAreYou: 'Wie ben jij?',
        readAloud: 'Voorlezen',
        inDays: { one: 'morgen', other: 'over {count} dagen' },
        today: 'vandaag',
        turnsAge: 'wordt {age}',
        dayOf: 'dag {index} van {count}',
    },
    wishes: {
        title: 'Wensen',
        intro: 'Wat staat er op de verlanglijstjes? Kinderen kiezen zelf een plaatje op de tablet.',
        add: 'Wens toevoegen',
        addShort: 'Wens',
        listOf: 'Wensen van {name}',
        editTitle: 'Wens bewerken',
        newTitle: 'Nieuwe wens',
        fieldTitle: 'Wat is het?',
        fieldTitleHint: 'Kort en duidelijk, bijvoorbeeld Loopfiets',
        fieldFor: 'Voor wie',
        fieldPicto: 'Plaatje',
        fieldNote: 'Toelichting',
        fieldNoteHint: 'Maat, kleur of merk (optioneel)',
        fieldUrl: 'Link naar de winkel',
        fieldUrlHint: 'Begint met https:// (optioneel)',
        fieldPrice: 'Ongeveer (€)',
        fieldPriority: 'Hoe graag?',
        priority1: 'Leuk',
        priority2: 'Heel leuk',
        priority3: 'Allerliefst',
        received: 'Gekregen',
        markReceived: 'Gekregen',
        fromTablet: 'zelf gekozen op de tablet: kies samen wat precies',
        removed: '{title} weggehaald.',
        receivedToast: '{title} staat bij gekregen.',
        share: 'Delen',
        shareTitle: 'Lijst van {name} delen',
        shareIntro: 'Iedereen met deze link kan de lijst zien en iets afstrepen, zonder account. {name} ziet nooit wie wat koopt.',
        shareCreate: 'Maak een deellink',
        shareNew: 'Nieuwe link',
        shareNewHint: 'De oude link werkt daarna niet meer.',
        shareStop: 'Stoppen met delen',
        shareStopped: 'De lijst is niet meer gedeeld.',
        shared: 'Gedeeld',
        reveal: 'Verklappen',
        revealHint: 'Laat zien wat al gekocht is. Let op: kinderen kunnen meekijken.',
        claimedBy: '{name} koopt dit',
        claimedAnon: 'Iemand koopt dit',
        boughtBy: '{name} heeft het gekocht',
        boughtAnon: 'Al gekocht',
        emptyTitle: 'Nog geen wensen',
        emptyBody: 'Voeg er een toe, of laat {name} er een kiezen op de tablet.',
        urlInvalid: 'Gebruik een link die begint met https://',
    },
    share: {
        title: 'Verlanglijstje van {name}',
        intro: 'Kies iets om te geven. {name} ziet niet wie wat koopt.',
        claim: 'Ik koop dit',
        claimTitle: 'Dit cadeau geven',
        claimName: 'Je naam (optioneel)',
        claimNameHint: 'Zodat anderen zien dat het geregeld is.',
        claimConfirm: 'Ik koop dit',
        mine: 'Jij koopt dit',
        mineBought: 'Jij hebt dit gekocht',
        bought: 'Gekocht',
        release: 'Toch niet',
        taken: 'Iemand koopt dit al',
        takenBy: '{name} koopt dit al',
        goneTitle: 'Deze link werkt niet meer',
        goneBody: 'Vraag om een nieuwe link.',
        emptyTitle: 'De lijst is nog leeg',
        emptyBody: 'Kijk later nog eens.',
        footer: 'Gemaakt met het gezinsbord van AMUMIN. Geen account nodig.',
        toWebshop: 'Bekijk in de winkel',
    },
    days: {
        title: 'Kalenders',
        intro: 'Verjaardagen, feestdagen, schoolvakanties en gekoppelde agenda’s staan vanzelf in de agenda.',
        upcoming: 'Binnenkort',
        upcomingEmpty: 'De komende weken niets bijzonders.',
        layers: 'Wat staat er in de agenda?',
        layerBirthdays: 'Verjaardagen',
        layerBirthdaysHint: 'Van het gezin en van families die hun verjaardagen delen.',
        layerHolidays: 'Feestdagen',
        layerHolidaysHint: 'Koningsdag, Pasen, Kerst en dagen als Moederdag.',
        layerSchool: 'Schoolvakanties',
        region: 'Regio',
        regionNoord: 'Noord',
        regionMidden: 'Midden',
        regionZuid: 'Zuid',
        regionOff: 'Uit',
        regionHint: 'Welke regio heeft jullie school? Herfst, kerst, voorjaar en mei zijn adviesdata.',
        birthdays: 'Verjaardagen',
        birthdaysHint: 'Vul een geboortedatum in, dan staat de verjaardag in de agenda.',
        birthDate: 'Geboortedatum van {name}',
        birthDateSaved: 'Verjaardag van {name} staat in de agenda.',
    },
    feeds: {
        title: 'Gekoppelde agenda’s',
        add: 'Agenda koppelen',
        addTitle: 'Agenda koppelen',
        intro: 'Haal school, sport en werk automatisch binnen. Elk half uur bijgewerkt.',
        provider: 'Waar komt de agenda vandaan?',
        providers: {
            google: 'Google',
            icloud: 'iCloud',
            outlook: 'Outlook',
            parro: 'Parro',
            magister: 'Magister',
            sportlink: 'Sportlink',
            other: 'Andere',
        },
        howto: {
            google: 'Agenda-instellingen → Agenda integreren → Geheim adres in iCal-indeling.',
            icloud: 'Agenda → deel de agenda → Openbare agenda → kopieer de webcal-link.',
            outlook: 'Instellingen → Agenda → Gedeelde agenda’s → Publiceer → ICS-link.',
            parro: 'Parro → Instellingen → Agenda koppelen → kopieer de link.',
            magister: 'Magister → Agenda → Agenda delen → kopieer de link.',
            sportlink: 'Voetbal.nl → Programma → Zet in je agenda → kopieer de iCal-link.',
            other: 'Elke link die eindigt op .ics of begint met webcal:// werkt.',
        },
        url: 'Link',
        urlHint: 'Begint met webcal:// of https://',
        name: 'Naam',
        namePlaceholder: 'Bijvoorbeeld School',
        forWho: 'Voor wie',
        forWhoHint: 'Niemand gekozen = iedereen.',
        review: 'Onbekende items eerst laten zien',
        reviewHint: 'Handig bij één schoolagenda voor meerdere kinderen.',
        rules: 'Regels',
        rulesHint: 'Staat dit in de titel? Dan hoort het bij…',
        ruleContains: 'Tekst',
        rulePlaceholder: 'bijvoorbeeld groep 3',
        addRule: 'Regel toevoegen',
        connect: 'Koppelen',
        connected: '{name} is gekoppeld: {count} afspraken.',
        refresh: 'Nu verversen',
        refreshed: 'Bijgewerkt.',
        remove: 'Ontkoppelen',
        removeConfirm: 'Agenda {name} ontkoppelen? De afspraken eruit verdwijnen uit jullie agenda.',
        removed: '{name} is ontkoppeld.',
        statusOk: 'Bijgewerkt {ago}',
        statusNew: 'Nog niet opgehaald',
        statusStale: 'Verouderd: al een dag niet bereikbaar',
        statusError: 'Niet gelukt: {error}',
        items: { one: '{count} afspraak', other: '{count} afspraken' },
        reviewCount: 'Onbekend ({count})',
        reviewTitle: 'Voor wie is dit?',
        reviewIntro: 'Kies per afspraak voor wie hij is. Dat blijft zo, ook na verversen.',
        hide: 'Verbergen',
        assign: 'Toewijzen',
        readonlyNote: 'Titel en tijd komen uit de gekoppelde agenda.',
        emptyTitle: 'Nog geen agenda gekoppeld',
        emptyBody: 'Haal school, sport en werk automatisch binnen.',
    },
    links: {
        title: 'Familie en vrienden',
        intro: 'Koppel opa en oma, de andere ouder of vrienden. Jullie kiezen zelf wat je deelt.',
        add: 'Familie koppelen',
        addTitle: 'Familie koppelen',
        codeHave: 'Code gekregen?',
        codePlaceholder: 'ABCD-EFGH',
        codeView: 'Bekijken',
        kind: 'Wie is het?',
        kinds: {
            grandparents: 'Opa en oma',
            coparent: 'Andere ouder',
            family: 'Familie',
            friends: 'Vrienden',
        },
        label: 'Hoe noemen jullie ze?',
        labelPlaceholder: 'Bijvoorbeeld Opa en oma Jansen',
        via: 'Hoe uitnodigen?',
        viaEmail: 'Per e-mail',
        viaCode: 'Met een code',
        email: 'E-mailadres',
        share: 'Wat delen jullie?',
        scopeAgenda: 'Agenda van',
        scopeAgendaHint: 'Alleen de afspraken van de kinderen die je kiest.',
        scopeBirthdays: 'Verjaardagen',
        scopeWishlists: 'Wensenlijstjes',
        scopeContact: 'Contactgegevens',
        scopeMessages: 'Berichten',
        scopeMessagesHint: 'Zij kunnen meedoen in gesprekken waar jullie ze aan toevoegen.',
        invite: 'Uitnodigen',
        invited: 'Uitnodiging verstuurd naar {email}.',
        codeReady: 'Geef deze code aan {label}',
        codeValid: 'Geldig tot {date}. Zij vullen hem in bij Familie → Code gekregen?',
        weShare: 'Wij delen',
        theyShare: 'Zij delen',
        nothing: 'nog niets',
        statusPending: 'uitgenodigd',
        statusActive: 'gekoppeld',
        statusRevoked: 'ontkoppeld',
        statusEnded: 'ontkoppeld door hen',
        expires: 'verloopt {date}',
        view: 'Bekijken',
        adjust: 'Aanpassen',
        revoke: 'Ontkoppelen',
        revokeInvite: 'Intrekken',
        remove: 'Verwijderen',
        guestMoreDays: 'Nog {count} dagen tonen',
        endedHint: 'Zij hebben de koppeling gestopt. Haal hem hier weg; opnieuw koppelen kan altijd.',
        revokeConfirm: 'Koppeling met {label} verbreken? Jullie zien daarna niets meer van elkaar.',
        revoked: 'Koppeling verbroken.',
        previewTitle: '{name} wil koppelen',
        previewShares: 'Zij delen met jullie:',
        accept: 'Koppelen',
        accepted: 'Gekoppeld met {name}. Kies hieronder wat jullie terug delen.',
        acceptLabel: 'Hoe noemen jullie ze?',
        inviteGone: 'Deze uitnodiging bestaat niet (meer) of is al gebruikt.',
        // Polish w4 ronde 2: geen doodlopende melding, maar zeggen wat je kunt doen.
        linkGoneTitle: 'Deze link werkt niet meer',
        linkGoneBody: 'Vraag om een nieuwe code, of vul hem hieronder in.',
        toFamily: 'Naar Familie',
        emailMismatch: 'Deze uitnodiging is voor een ander e-mailadres.',
        alreadyLinked: 'Jullie zijn al gekoppeld.',
        contactTitle: 'Ons contactkaartje',
        contactHint: 'Alleen zichtbaar voor families met wie je contactgegevens deelt.',
        address: 'Adres',
        phone: 'Telefoon',
        contactEmail: 'E-mail',
        note: 'Notitie',
        emptyTitle: 'Nog niemand gekoppeld',
        emptyBody: 'Koppel opa en oma: zij zien verjaardagen en wensen, en kunnen berichtjes sturen.',
        guestTitle: '{name}',
        guestNothing: 'Nog niets gedeeld',
        guestNothingBody: 'Zij kiezen zelf wat ze laten zien.',
        guestAgenda: 'Agenda (14 dagen)',
        guestBirthdays: 'Binnenkort jarig',
        guestWishes: 'Wensen',
        guestContact: 'Contact',
        guestNoEvents: 'Geen afspraken de komende twee weken.',
    },
    messages: {
        title: 'Berichten',
        intro: 'Veilig: alleen het gezin en families die jullie koppelen. Geen reclame, geen algoritmes.',
        parentsReadAll: 'Ouders lezen alle gesprekken mee, ook die van de kinderen.',
        family: 'Gezin',
        add: 'Gesprek',
        addTitle: 'Nieuw gesprek',
        fieldTitle: 'Naam van het gesprek',
        fieldTitlePlaceholder: 'Bijvoorbeeld Opa en oma',
        fieldWho: 'Wie doen er mee?',
        fieldLinks: 'Gekoppelde families',
        fieldLinksHint: 'Alleen families met wie jullie berichten delen.',
        create: 'Gesprek maken',
        placeholder: 'Schrijf een bericht…',
        send: 'Sturen',
        stickers: 'Stickers',
        record: 'Inspreken',
        recording: 'Neemt op… tik om te stoppen',
        voice: 'Spraakbericht',
        play: 'Afspelen',
        hidden: 'Bericht verborgen door een ouder',
        hide: 'Verbergen',
        fromLinked: 'Van gekoppelde families',
        pickConversation: 'Kies een gesprek',
        emptyTitle: 'Nog geen berichten',
        emptyBody: 'Begin in het gezinsgesprek.',
        kidEmptyBody: 'Stuur een sticker!',
        newMessages: 'nieuwe berichten',
        noMember: 'Koppel je login eerst aan een gezinslid om berichten te sturen.',
        sticker: 'Sticker',
    },
    phrase: {
        love: 'Ik hou van je',
        comeHome: 'Kom je naar huis?',
        hungry: 'Ik heb honger',
        done: 'Klaar!',
        miss: 'Ik mis je',
        play: 'Kom je spelen?',
    },
    /** Wat een kind op de tablet kiest, als zelfstandig naamwoord (titel van de wens). */
    wishPicto: {
        gift: 'Cadeautje',
        play: 'Knuffel',
        puzzle: 'Puzzel',
        drawing: 'Tekenspullen',
        crafts: 'Knutselspullen',
        reading: 'Boek',
        gaming: 'Spelcomputer',
        cycling: 'Fiets',
        soccer: 'Voetbal',
        skating: 'Skates',
        swimming: 'Zwemspullen',
        dance: 'Dansles',
        'music-lesson': 'Muziekles',
        guitar: 'Gitaar',
        piano: 'Piano',
        drums: 'Drumstel',
        unicorn: 'Eenhoorn',
        dino: 'Dinosaurus',
        rocket: 'Raket',
        bear: 'Beer',
        rabbit: 'Konijn',
        cat: 'Poes',
        dolphin: 'Dolfijn',
        butterfly: 'Vlinder',
        rainbow: 'Regenboog',
        sunflower: 'Bloemen',
        'ice-cream': 'IJsje',
        pizza: 'Pizza',
        popcorn: 'Popcorn',
        cinema: 'Naar de film',
        zoo: 'Naar de dierentuin',
        museum: 'Naar het museum',
        camping: 'Kamperen',
        sleepover: 'Logeren',
        party: 'Feestje',
        trophy: 'Beker',
    },
    kiosk: {
        wishesEntry: 'Wensen',
        messagesEntry: 'Berichten',
        myWishes: 'Mijn wensen',
        newWish: 'Nieuwe wens',
        pickPicture: 'Kies een plaatje',
        howMuch: 'Hoe graag wil je het?',
        addToList: 'Op mijn lijst',
        removeAsk: 'Weghalen?',
        wishAdded: 'Staat op je lijst!',
        /** Rustig, buiten het thema Kinderen. */
        wishAddedCalm: 'Staat op je lijst',
        noWishes: 'Nog geen wensen',
        noWishesBody: 'Tik op het plusje en kies een plaatje.',
        conversations: 'Gesprekken',
        unread: { one: '{count} nieuw', other: '{count} nieuw' },
        // Polish w4 ronde 1: Oeps bij wensen en berichten, zelf typen voor lezers.
        wishRemoved: '{title} is weg',
        messageSent: 'Verstuurd',
        oops: 'Oeps',
        typeOwn: 'Typ zelf',
        typeLabel: 'Jouw bericht',
        typePlaceholder: 'Wat wil je zeggen?',
        send: 'Sturen',
        closeTyping: 'Klaar met typen',
        // Polish w4 ronde 2: onthouden gezicht, stip i.p.v. teller, geen dubbele wensen.
        notYou: 'Niet jij?',
        newMessages: 'Nieuwe berichten',
        alreadyOnList: 'Staat al op je lijst!',
        alreadyOnListCalm: 'Staat al op je lijst',
        morePictures: 'Meer plaatjes',
        morePhrases: 'Meer zinnetjes',
    },
};
//# sourceMappingURL=family.nl.js.map